import React, { memo, useEffect, useState } from "react";
import { Handle, Position } from "@xyflow/react";
import { MDBAutocomplete, MDBBtn, MDBIcon, MDBSpinner } from "mdb-react-ui-kit";
import { getMisc } from "../../apiclients/streamsapi_bridge";
import CFNodeUI from "./NodeUI";
import { set } from "react-hook-form";
import { customSearch } from "../CustomSearchUtil/CustomSearch";
export default memo(({ data, isConnectable }) => {
  const [isloading, setIsloading] = useState(true);
  function onDelete(id) {
    data.onDelete(id);
  }
  const [selected, setSelected] = useState(
    data.selected_object ? data.selected_object.label : ""
  );
  const [defaultData, setDefaultData] = useState([]);
  const [displayValuess, setDisplayValuess] = useState([]);

  async function fetchAAMiscData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["users_and_extensions"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    console.log(tdata);
    if (!tdata) {
      window.alert(`info with id  not found`);
    }

    const userList = tdata?.misc?.users_and_extensions?.users ?? [];
    const groupList = tdata?.misc?.users_and_extensions?.groups ?? [];

    const mergeWithSortList = [...userList, ...groupList];
    console.log(mergeWithSortList);
    setDefaultData(mergeWithSortList);
    setDisplayValuess(mergeWithSortList);
    setIsloading(false);
  }

  useEffect(() => {
    fetchAAMiscData();
  }, []);

  const [customData, setCustomData] = useState(displayValuess);
  const onCustomSearch = (value) => {
    console.log(value);
    setCustomData(
      customSearch(displayValuess, value, ['title', 'extension'])
    
    );
  };
  let sharedWindow = null; // only one popup for all routes

  const openLocation = (e) => {
    e.preventDefault();
    e.stopPropagation();
  
    const selectedObj = data?.selected_object;
    const label = selectedObj?.label || "";
    const code = selectedObj?.code;
    const category = selectedObj?.category;
    const entityType = selectedObj?.entity_type;
  
    localStorage.setItem("selectedItem", label);
    localStorage.setItem("userInfo", JSON.stringify(code));
  
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const width = screenWidth * 0.8;
    const height = screenHeight * 0.8;
    const left = (screenWidth - width) / 2;
    const top = (screenHeight - height) / 2;
    const windowFeatures = `width=${width},height=${height},top=${top},left=${left}`;
  
   
    let route = "";
    let storageKey = "";
    let storageData = {};
    let msgHandlerName = "";
    let actionValue = "";
  
    if (category === "USER" && entityType === 1) {
      route = "/useredit";
      storageKey = "userDetailsInfo";
      storageData = {
        code: selectedObj.code,
        title: selectedObj.title,
        extension: selectedObj.extension,
      };
      msgHandlerName = "receiveMessageFromAAChild";
      actionValue = "User";
    } else if (category === "(AA)" && entityType === 2) {
      route = "/accinfo";
      storageKey = "AAGrpInfo";
      storageData = {
        code: selectedObj.code,
        title: selectedObj.title,
      };
      msgHandlerName = "receiveMessageFromAAChild";
      actionValue = "Auto-Attendent";
    } else if (category === "(HUNT)" && entityType === 2) {
      route = "/huntaccinfo";
      storageKey = "huntGrpInfo";
      storageData = selectedObj.code;
      msgHandlerName = "receiveMessageFromHuntChild";
      actionValue = "Hunt group";
    } else {
      return; 
    }
  
    localStorage.setItem(storageKey, JSON.stringify(storageData));
  
    const windowName = "routeWindow";
  
    if (sharedWindow && !sharedWindow.closed) {
      sharedWindow.focus();
      sharedWindow.location.href = route; 
    } else {
      sharedWindow = window.open(route, windowName, windowFeatures);
    }
  
    window[msgHandlerName] = (nodeFlag) => {
      if (nodeFlag === 1) {
        data.actionExecutor({ action: 17, value: actionValue });
        console.log("Received message from child:", nodeFlag);
      }
    };
  };
  
  
  
  
  const handleFocus = (event) => {
    if (event.target.value != "") {
      event.target.select();
      setCustomData(displayValuess);
    }
  };
  function getType(type,category) {
    let textVal = "";
    switch (type) {
      case 1:
        textVal = "";
        break;
      case 2:
        if(category){
          textVal = category ;
          break;
        }

    }
    return textVal;
  }
  return (
    <>
      <CFNodeUI
        headerClass="userExtensionNodeHeader"
        data={data}
        deletable={true}
        onDelete={onDelete}
        isConnectable={isConnectable}
        bodyContnent={
          <>
            <div className="nodeSelectLinkIcon">
              <MDBAutocomplete
                data={customData}
                title={selected}
                displayValue={(item) => {
                  const categoryPart = item.entity_type   == 2
                    ? ` : ${getType(item.entity_type , item.category)}`
                    : "";
                  const extensionpart = item.extension
                    ? `  ${item.extension} :`
                    : "";
                    console.log("Item value" , JSON.stringify(item))
                  return `${extensionpart} ${item.title}${categoryPart}`;
                }}
                placeholder={"Choose User or Extension"}
                value={selected}
                onChange={(val) => setSelected(val)}
                onClick={handleFocus}
                onSelect={(e) =>
                  (function processClick(value) {
                    console.log(value.split(":")[1].trim());
                    let selectedObj = customData.filter(
                      (selectedObj) =>
                        selectedObj.extension === value.split(":")[0].trim() * 1
                    );
                    console.log(customData);
                    console.log(selectedObj);
                    data.selected_object = {
                      label: value,
                      ...selectedObj[0],
                      code: selectedObj[0].uniqueId
                        ? selectedObj[0].uniqueId
                        : "",
                      entity_type: selectedObj[0].entity_type
                        ? selectedObj[0].entity_type
                        : "",
                    };

                    data.actionExecutor({
                      action: 2,
                      value: selectedObj || -1,
                    });
                  })(e)
                }
                onSearch={onCustomSearch}
              />

              {data.selected_object && (
                <>
                  <MDBIcon
                    fas
                    icon="external-link-square-alt"
                    className="nodeLinkIcon"
                    onClick={(e) => openLocation(e)}
                  />
                </>
              )}
            </div>
          </>
        }
        targetNode={true}
      />
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
});
